import { takeLatest } from 'redux-saga/effects'

import {
  getLaborerEToIRequests as getLaborerEToIRequestsAction,
  getLaborerEToIRequestById as getLaborerEToIRequestByIdAction,
  submitReplyForLaborerEToIRequest as submitReplyForLaborerEToIRequestAction,
} from 'redux/actionCreators/laborerPortalAPI/newDlTransfers'
import Actions from 'redux/actions'
import { getSimpleRequestHandler } from 'saga/utils'
import laborerNewDlTransferApi from 'api/laborerPortalAPI/newDlTransferApi'

const getLaborerEToIRequests = getSimpleRequestHandler<
  typeof laborerNewDlTransferApi.getLaborerEToIRequests,
  ReturnType<typeof getLaborerEToIRequestsAction>
>({
  actionLoading: Actions.GET_LABORER_E_TO_I_REQUESTS_ASYNC,
  actionSuccess: Actions.GET_LABORER_E_TO_I_REQUESTS_SUCCESS,
  actionFail: Actions.GET_LABORER_E_TO_I_REQUESTS_FAIL,
  callApiFn: laborerNewDlTransferApi.getLaborerEToIRequests,
})

const getLaborerEToIRequestById = getSimpleRequestHandler<
  typeof laborerNewDlTransferApi.getLaborerEToIRequestById,
  ReturnType<typeof getLaborerEToIRequestByIdAction>
>({
  actionLoading: Actions.GET_LABORER_E_TO_I_REQUEST_BY_ID_ASYNC,
  actionSuccess: Actions.GET_LABORER_E_TO_I_REQUEST_BY_ID_SUCCESS,
  actionFail: Actions.GET_LABORER_E_TO_I_REQUEST_BY_ID_FAIL,
  callApiFn: laborerNewDlTransferApi.getLaborerEToIRequestById,
})

const submitReplyForLaborerEToIRequest = getSimpleRequestHandler<
  typeof laborerNewDlTransferApi.submitReplyForLaborerEToIRequest,
  ReturnType<typeof submitReplyForLaborerEToIRequestAction>
>({
  actionLoading: Actions.SUBMIT_REPLY_FOR_LABORER_E_TO_I_REQUEST_ASYNC,
  actionSuccess: Actions.SUBMIT_REPLY_FOR_LABORER_E_TO_I_REQUEST_SUCCESS,
  actionFail: Actions.SUBMIT_REPLY_FOR_LABORER_E_TO_I_REQUEST_FAIL,
  callApiFn: laborerNewDlTransferApi.submitReplyForLaborerEToIRequest,
})

export default [
  takeLatest(Actions.GET_LABORER_E_TO_I_REQUESTS, getLaborerEToIRequests),
  takeLatest(Actions.GET_LABORER_E_TO_I_REQUEST_BY_ID, getLaborerEToIRequestById),
  takeLatest(Actions.SUBMIT_REPLY_FOR_LABORER_E_TO_I_REQUEST, submitReplyForLaborerEToIRequest),
]
